import React from 'react';
import { styled } from '@mui/material/styles';
import Chip from '@mui/material/Chip';

const StyledChip = styled(Chip)(({ status }) => {
  let backgroundColor = 'transparent';
  let color = '#333';

  const normalizedStatus = status ? status.toString().toLowerCase().trim() : 'unknown';
  if (normalizedStatus === 'in progress') {
    color = '#17A5D9';
  } else if (normalizedStatus === 'pipeline') {
    color = '#D36600';
  } else if (normalizedStatus === 'completed') {
    color = '#059D38';
  } else if (normalizedStatus === 'n/a' || normalizedStatus === 'unknown') {
    color = '#666';
  }

  return {
    backgroundColor,
    color,
    fontWeight: 'bold',
    padding: '2px 8px',
    fontFamily: 'Mulish, sans-serif',
    fontSize: '12px',
    whiteSpace: 'nowrap', // Enforce single-line text
    overflow: 'hidden', // Hide overflow content
    textOverflow: 'ellipsis', // Show ellipsis for overflow
    maxWidth: '100%', // Ensure it fits within the column
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    height: 'auto',
    minHeight: '24px',
    '& .MuiChip-label': {
      color: 'inherit',
      fontWeight: 'inherit',
      whiteSpace: 'nowrap', // Enforce single-line text for the label
      overflow: 'hidden', // Hide overflow content
      textOverflow: 'ellipsis', // Show ellipsis for overflow
      padding: '0 4px',
      display: 'block',
      textAlign: 'center',
    },
    '&:not(.MuiChip-outlined)': {
      color: `${color} !important`,
    },
  };
});

const StatusPill = ({ status }) => {
  return <StyledChip label={status || 'Unknown'} status={status} title={status || 'Unknown'} />;
};

export default StatusPill;